let cocNumberInput = $('#cocNumber_input');
let cocNumberSelect = $('#cocNumber_select');
let companyNameInput = $('#companyName');
let cocLookUpButton = $('#button_findCoc');
let cocEnterManuallyButton = $('#button_enterManually');
let cocLookUpNote = $('#note_findCoc');
let cocEnterManuallyNote = $('#note_enterManually');
let noMatchesFoundMessage = 'Could not find any matches for your Company Name';

cocLookUpButton.on('click', function () {

    cocNumberInput.addClass('loading');
    cocNumberInput.prop('disabled', true);
    cocLookUpButton.prop('disabled', true);

    $.ajax({
        method: 'POST',
        url: '/findCompanies',
        data: {'companyName': companyNameInput.val()},
        success: function (companies) {

            cocNumberInput.val('');
            cocNumberSelect.empty();
            cocLookUpButton.prop('disabled', false);
            cocNumberInput.removeClass('loading');
            cocNumberInput.prop('disabled', false);

            $.each(companies, function (index, company) {
                let option = '<option value="{kvknumber}">{kvknumber} - {tradename}, {establishmentstreet}, {establishmentcity}</option>';
                option = option.replace(/{kvknumber}/g, company.kvknumber);
                option = option.replace('{tradename}', company.tradename);
                option = option.replace('{establishmentstreet}', company.establishmentstreet);
                option = option.replace('{establishmentcity}', company.establishmentcity);

                cocNumberSelect.append(option);
            });

            if (companies.length > 0) {
                cocNumberInput.hide();
                cocLookUpButton.hide();
                cocLookUpNote.hide();
                cocNumberSelect.show();
                cocEnterManuallyButton.show();
                cocEnterManuallyNote.show();
            } else {
                cocNumberInput.val(noMatchesFoundMessage);
            }
        },
        error: function (response, status, error) {
            console.log(response, status, error);
        }
    });
});

cocEnterManuallyButton.on('click', function () {
    cocNumberSelect.hide();
    cocNumberSelect.empty();
    cocNumberInput.show();
    cocEnterManuallyButton.hide();
    cocEnterManuallyNote.hide();
    cocLookUpButton.show();
    cocLookUpNote.show();
});

cocNumberInput.on('focus', function () {
    if (cocNumberInput.val() === noMatchesFoundMessage) {
        cocNumberInput.val('');
    }
});

$('#registration-cva-button').on('click', function () {
    iris.setButtonLoading($('#registration-cva-button'));

    if (cocNumberSelect.val()) {
        cocNumberInput.val(cocNumberSelect.val());
    }

    $('#registration-cva-form').submit();
});

// user replied that they already have a service center account
$('a#existing-user-yes').on('click', function () {
    $('div#registration-cva-account-question').hide();
    $('div#registration-cva-login').show();
});

// user replied they don't have a service center account yet
$('a#existing-user-no').on('click', function () {
    window.location.href = '/cloud-value-academy-register';
});

$('div#login').on('click', function () {
    $('form#login-cva').submit();
});